module.exports = __webpack_public_path__ + "img/prd_pack.f0790428.png";